/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LandlordSlaContractDto } from './LandlordSlaContractDto';
import {
    LandlordSlaContractDtoFromJSON,
    LandlordSlaContractDtoFromJSONTyped,
    LandlordSlaContractDtoToJSON,
    LandlordSlaContractDtoToJSONTyped,
} from './LandlordSlaContractDto';

/**
 * 
 * @export
 * @interface UpdateLandlordSlaResponseDto
 */
export interface UpdateLandlordSlaResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordSlaResponseDto
     */
    relationshipId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordSlaResponseDto
     */
    partnerOrgId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordSlaResponseDto
     */
    partnerName: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLandlordSlaResponseDto
     */
    isSameCompanyAsOperator: boolean;
    /**
     * 
     * @type {LandlordSlaContractDto}
     * @memberof UpdateLandlordSlaResponseDto
     */
    slaContract?: LandlordSlaContractDto | null;
}

/**
 * Check if a given object implements the UpdateLandlordSlaResponseDto interface.
 */
export function instanceOfUpdateLandlordSlaResponseDto(value: object): value is UpdateLandlordSlaResponseDto {
    if (!('relationshipId' in value) || value['relationshipId'] === undefined) return false;
    if (!('partnerOrgId' in value) || value['partnerOrgId'] === undefined) return false;
    if (!('partnerName' in value) || value['partnerName'] === undefined) return false;
    if (!('isSameCompanyAsOperator' in value) || value['isSameCompanyAsOperator'] === undefined) return false;
    return true;
}

export function UpdateLandlordSlaResponseDtoFromJSON(json: any): UpdateLandlordSlaResponseDto {
    return UpdateLandlordSlaResponseDtoFromJSONTyped(json, false);
}

export function UpdateLandlordSlaResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLandlordSlaResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'relationshipId': json['relationshipId'],
        'partnerOrgId': json['partnerOrgId'],
        'partnerName': json['partnerName'],
        'isSameCompanyAsOperator': json['isSameCompanyAsOperator'],
        'slaContract': json['slaContract'] == null ? undefined : LandlordSlaContractDtoFromJSON(json['slaContract']),
    };
}

export function UpdateLandlordSlaResponseDtoToJSON(json: any): UpdateLandlordSlaResponseDto {
    return UpdateLandlordSlaResponseDtoToJSONTyped(json, false);
}

export function UpdateLandlordSlaResponseDtoToJSONTyped(value?: UpdateLandlordSlaResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'relationshipId': value['relationshipId'],
        'partnerOrgId': value['partnerOrgId'],
        'partnerName': value['partnerName'],
        'isSameCompanyAsOperator': value['isSameCompanyAsOperator'],
        'slaContract': LandlordSlaContractDtoToJSON(value['slaContract']),
    };
}

